import React, { useEffect, useState } from "react";
import paymentStore from "../../../stores/paymentStore";
import orderStore from "../../../stores/orderStore";
import usersStore from "../../../stores/usersStore";
import productStore from "../../../stores/productStore";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
} from "@mui/material";
import OrderColumn from "../OrderColumn";
import OrderRow from "../OrderRow";

// Icon
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";

const AllOrderTab = ({
  isDashboard = false,
  dataLoading,
  orderID,
  customerName,
  staringDate,
  endingDate,
  staringPrice,
  endingPrice,
  deliveryStatus,
}) => {
  const PaymentStore = paymentStore();
  const OrderStore = orderStore();
  const UsersStore = usersStore();
  const ProductStore = productStore();

  const [rows, setRows] = useState(null);
  const [emptyRows, setEmptyRows] = useState(null);
  const [visibleRows, setVisibleRows] = useState(null);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    if (
      !ProductStore.isLoading &&
      !PaymentStore.isLoading &&
      !OrderStore.isLoading &&
      !UsersStore.isLoading
    ) {
      const myRows = [];
      if (PaymentStore.mPaymentDetails) {
        PaymentStore.mPaymentDetails.map((payment) => {
          let totalQTY = 0;
          let delivery_status = "";
          const productData = [];
          OrderStore.orderDetail.map((order) => {
            if (payment._id === order.paymentID) {
              totalQTY = totalQTY + order.quantity;
              delivery_status = order.order_delivery_status;

              ProductStore.mProduct.map((product) => {
                if (product._id === order.productID) {
                  productData.push({
                    _id: order._id,
                    productName: product.productName,
                    qty: order.quantity,
                    regularPrice: order.purchasePrice,
                    size: order.selectedSize,
                    color: order.selectedColor?.toString(),
                  });
                }
              });
            }
          });
          let username = "";
          let email = "";
          UsersStore.allUser.map((user) => {
            if (user._id === payment.userID) {
              username = user.firstName + " " + user.lastName;
              email = user.email;
            }
          });
          myRows.push({
            _id: payment._id,
            username,
            email,
            orderDate: payment.payment_at,
            totalQTY,
            price: payment.total,
            delivery_status,
            order_products: [...productData],
          });
        });
      }
      setRows(myRows);
    }
  }, [
    ProductStore.isLoading,
    PaymentStore.isLoading,
    OrderStore.isLoading,
    UsersStore.isLoading,
  ]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.name);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  // useEffect(() => {
  //   setRowData();
  // }, [order, orderBy, page, rowsPerPage, rows]);

  const setRowData = ({ myRows }) => {
    const data = stableSort(myRows, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    setVisibleRows(data);

    const emptyRowsData =
      page > 0 ? Math.max(0, (1 + page) * rowsPerPage - myRows.length) : 0;
    setEmptyRows(emptyRowsData);
  };

  useEffect(() => {
    if (rows) {
      let filterData = rows;
      if (OrderStore.orderFilterApply !== 0) {
        if (orderID !== "") {
          const orderIDFilter = filterData.filter((item) => {
            return item._id.toLowerCase().includes(orderID.toLowerCase());
          });
          filterData = orderIDFilter;
        }

        if (customerName !== "") {
          const customerNameFilter = filterData.filter((item) => {
            return item.username
              .toLowerCase()
              .includes(customerName.toLowerCase());
          });
          filterData = customerNameFilter;
        }

        if (staringDate !== null && endingDate !== null) {
          const dateFilter = filterData.filter((item) => {
            const orderDate = new Date(item.orderDate);
            const endDate = new Date(endingDate);
            endDate.setDate(endDate.getDate() + 1);

            if (staringDate <= orderDate && orderDate <= endDate) {
              return item;
            }
          });
          filterData = dateFilter;
        }

        if (staringPrice !== "" && endingPrice !== "") {
          const priceFilter = filterData.filter((item) => {
            if (staringPrice <= item.price && item.price <= endingPrice) {
              return item;
            }
          });
          filterData = priceFilter;
        }

        if (deliveryStatus !== "") {
          const statusFilter = filterData.filter((item) => {
            if (item.delivery_status === deliveryStatus) {
              return item;
            }
          });
          filterData = statusFilter;
        }
      }
      if (filterData.length) {
        setRowData({ myRows: filterData });
      } else {
        setVisibleRows(null);
      }
    }
  }, [OrderStore.orderFilterApply, order, orderBy, page, rowsPerPage, rows]);

  return (
    <div className="all-order-tab">
      <TableContainer>
        <Table aria-label="collapsible table" size={dense ? "small" : "medium"}>
          <OrderColumn
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={visibleRows ? visibleRows.length : 0}
            dataLoading={dataLoading}
          />
          <TableBody>
            {visibleRows ? (
              isDashboard ? (
                visibleRows
                  .slice(0)
                  .reverse()
                  .slice(0, 5)
                  .map((row) => <OrderRow key={row._id} row={row} />)
              ) : (
                visibleRows
                  .slice(0)
                  .reverse()
                  .map((row) => <OrderRow key={row._id} row={row} />)
              )
            ) : (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * 5,
                }}
              >
                <TableCell colSpan={8}>
                  <div className="no-order-data">
                    <div className="content">
                      <DescriptionRoundedIcon className="icon" />
                      <p>{dataLoading ? "Loading..." : "No Data"}</p>
                    </div>
                  </div>
                </TableCell>
              </TableRow>
            )}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 65.5) * emptyRows,
                }}
              >
                <TableCell colSpan={8} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isDashboard ? undefined : (
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={visibleRows ? visibleRows.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default AllOrderTab;
